import React, { Fragment } from "react"
import classnames from "classnames"
import styles from "./styles.css"

const ContractsAndOrdersSkeleton = () => {
  const titleClasses = classnames(styles.skeletonText, styles.skeleton)
  const cardContainerClasses = classnames(
    styles.commons,
    styles.headerSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const subTitleClasses = classnames(styles.skeletonSubTitle, styles.skeleton)
  const containerSelectClasses = classnames(
    styles.containerSelect,
    styles.skeleton
  )
  const buttonClasses = classnames(styles.button, styles.skeleton)

  return (
    <Fragment>
      <div className={titleClasses}></div>
      <div className={cardContainerClasses}>
        <div className={subTitleClasses}></div>
        <div className={containerSelectClasses}></div>
      </div>

      <div className={titleClasses}></div>
      <div className={cardContainerClasses}>
        <div className={subTitleClasses}></div>
        <div className="u-flex">
          <div className={containerSelectClasses}></div>
          <div className={buttonClasses}></div>
        </div>
      </div>
    </Fragment>
  )
}

export default ContractsAndOrdersSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/ContractsAndOrdersSkeleton/index.js